import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Header from './header';
import Content from './content';
import Footer from './footer';

import './modal-window.less';

class ModalWindow extends React.Component
{
  static propTypes = {
    onCloseDialogClick: PropTypes.func.isRequired,
    withPadding: PropTypes.bool,
    withoutHeightCalc: PropTypes.bool,
    size: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number
    }).isRequired,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    withPadding: true,
    withoutHeightCalc: true
  };

  static Header = Header;
  static Content = Content;
  static Footer = Footer;

  stopClickEvent = (e) =>
  {
    e.stopPropagation();
  };

  render()
  {
    const {
      onCloseDialogClick,
      withPadding,
      size: { width, height },
    } = this.props;

    const children = this.props.children;

    const overlayClassNames = classnames({
      '-wa-modal__overlay': true,
      '-wa-modal__overlay_without-padding': !withPadding
    });

    return (
      <div className={overlayClassNames} onClick={this.stopClickEvent}>
        <div className="-wa-modal__wrapper" style={{ width, height }} >
          <div
            className="-wa-modal__close-button"
            onClick={onCloseDialogClick}
            onKeyDown={onCloseDialogClick}
          />
          <div className="-wa-modal__rounded">
            {children}
          </div>
        </div>
      </div>
    );
  }
}


export default ModalWindow;